export default __webpack_public_path__ + "static/the_balance-7015bcf829f84e17883a569997a310e6.png";